type ValidationRuleId = number;

export interface ValidationRule {
  id: ValidationRuleId;
  rule: string;
}

export enum CharacterType {
  Latin = 1,
  Cyrillic = 2,
  Hieroglyphs = 3,
}

export interface Language {
  id: string | null;
  name: string;
  characterType: CharacterType;
}

export type LanguageUpdate = Omit<Language, "id" | "validationRules"> & {
  isoCode: string;
};

export type LanguageSummary = Pick<Language, "id" | "name">;

export interface LanguagesPage {
  list: LanguageSummary[];
  totalCount: number;
}

interface ValidationRuleRegular {
  id: number;
  rule: string;
}

export type ValidationRulesRegular = ValidationRuleRegular[];

export interface ValidationRulesAdditional {
  startDisallowedCharacters: string[];
  endDisallowedCharacters: string[];
  beforeSpecialCharactersDisallowed: string[];
  afterSpecialCharactersDisallowed: string[];
}

export interface ValidationRules {
  rules: ValidationRulesRegular;
  additionalRules: ValidationRulesAdditional;
}
